// extracted by mini-css-extract-plugin
export default {"cell":"Cell_cell__6gm6F"};